import React from 'react';

const Facebook = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M23.9998 12.1714C23.9998 18.7988 18.6272 24.1714 11.9998 24.1714C5.37234 24.1714 -0.000244141 18.7988 -0.000244141 12.1714C-0.000244141 5.54397 5.37234 0.171387 11.9998 0.171387C18.6272 0.171387 23.9998 5.54397 23.9998 12.1714ZM13.5958 12.6411H15.7369L16.0203 9.88683H13.596V8.26431C13.596 7.65573 13.9981 7.51284 14.2841 7.51284H16.0276V4.83681L13.6246 4.82675C10.9577 4.82675 10.3517 6.82447 10.3517 8.10024V9.88426H8.80888V12.6411H10.3517V20.4857H13.5958V12.6411Z" fill="white"/>
  </svg>
);

export default Facebook;